import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DgxComponentsAccordionModule } from '@domgen/dgx-fe-components/accordion';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { DgxComponentsPanelModule } from '@domgen/dgx-fe-components/panel';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@shared/shared.module';
import { ViewOffersModule } from '@view-offers/view-offers.module';
import { CompareModule } from '../compare/compare.module';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import { AdditionalServicesEffects } from './store/effects/index';
import {
  ADDITIONAL_SERVICES_FEATURE,
  additionalServicesReducers,
} from './store/reducers/index';

@NgModule({
  declarations: [...fromComponents.components, ...fromContainers.containers],
  imports: [
    CommonModule,
    SharedModule,
    ViewOffersModule,
    CompareModule,
    StoreModule.forFeature(
      ADDITIONAL_SERVICES_FEATURE,
      additionalServicesReducers
    ),
    EffectsModule.forFeature(AdditionalServicesEffects),
    DgxComponentsButtonModule,
    RouterModule,
    DgxComponentsAccordionModule,
    DgxComponentsPanelModule,
    DgxComponentsIconModule,
  ],
  exports: [...fromComponents.components, ...fromContainers.containers],
})
export class AdditionalServicesModule {}
